import { render } from "./Int.vue?vue&type=template&id=3a5aa57f"
import script from "./Int.vue?vue&type=script&lang=js"
export * from "./Int.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__